import styled from 'styled-components';

export const EditProfileBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const EditPersonalInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 620px;
  width: 650px;
  border: 1px solid ${({ theme }) => theme.mainColor};
  border-radius: 5px;
`;

export const EditAvatarBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const UserImgProfile = styled.img`
  height: 150px;
  width: 150px;
  border-radius: 75px;
`;

export const EditNameBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: auto;
  width: 100%;
`;

export const EditBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 100%;
`;

export const EditRowBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  width: 95%;
`;

export const SpanEditProfile = styled.span`
  width: 200px;
  height: 45px;
  margin-left: 35px;
`;

export const ShadowEditProfileBlock = styled.div`
  width: 200px;
  height: 64px;
`;
